import { render } from "./GameInput.vue?vue&type=template&id=0987eab8&scoped=true"
import script from "./GameInput.vue?vue&type=script&lang=js"
export * from "./GameInput.vue?vue&type=script&lang=js"

import "./GameInput.vue?vue&type=style&index=0&id=0987eab8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0987eab8"]])

export default __exports__